export default "__VITE_ASSET__9722cd47__"